<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Approve Payment Details">
      <v-card-actions>
        <router-link :to="{ name: 'ApprovePaymentList' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
      </v-card-actions>
      <v-card rounded="lg" class="my-4">
        <v-row no-gutters>
          <v-col cols="12" md="4">
            <div class="pl-2 pt-2">
              <v-img :src="tots_image" width="120"> </v-img>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-card-subtitle class="font-weight-medium"><span class="body-1">Enquiry Code :</span> {{ studentInfo && studentInfo.enquiryCode ? studentInfo.enquiryCode : '' }}</v-card-subtitle>
          </v-col>
          <v-col cols="12" md="4">
            <v-card-subtitle class="font-weight-medium"><span class="body-1"> Student Name :</span> <span class="text-button mb-1">{{ studentInfo && studentInfo.name ? studentInfo.name : '' }}</span></v-card-subtitle>
          </v-col>

          <v-col cols="12" md="4">
            <v-card-subtitle class="font-weight-medium"
              ><span class="body-1">Franchisee Name :</span> <span class="text-button mb-1">{{ studentInfo && studentInfo.franchiseeName ? studentInfo.franchiseeName : '' }}</span></v-card-subtitle
            >
          </v-col>

          <v-col cols="12" md="4">
            <v-card-subtitle class="font-weight-medium"><span class="body-1">Academic Year :</span> {{ studentInfo && studentInfo.academicYear ? studentInfo.academicYear : '' }}</v-card-subtitle>
          </v-col>

          <v-col cols="12" md="4">
            <v-card-subtitle class="font-weight-medium"><span class="body-1">Class :</span> {{ studentInfo && studentInfo.class ? studentInfo.class : '' }}</v-card-subtitle>
          </v-col>
          <v-col cols="12" md="4">
            <v-card-subtitle class="font-weight-medium"><span class="body-1">Parent / Guardian Name :</span> <span class="text-button mb-1">{{ studentInfo && studentInfo.fatherName ? studentInfo.fatherName : '' }}</span></v-card-subtitle>
          </v-col>
          <v-col cols="12" md="4">
            <v-card-subtitle class="font-weight-medium"><span class="body-1">Mobile :</span> {{ studentInfo && studentInfo.mobile ? studentInfo.mobile : '' }}</v-card-subtitle>
          </v-col>
          <v-col cols="12" md="4">
            <v-card-subtitle class="font-weight-medium"><span class="body-1">Email :</span> <span class="text-button mb-1">{{ studentInfo && studentInfo.email ? studentInfo.email : '' }}</span></v-card-subtitle>
          </v-col>
          <v-col cols="12" md="4">
            <v-card-subtitle class="font-weight-medium">
              <span class="body-1">Student Gender : </span>
              <div v-if="studentInfo.gender ==='Female' || studentInfo.gender ==='FEMALE'" class="text-button mb-1" v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Female' ? 'Girl' : '-'||studentInfo && studentInfo.gender && studentInfo.gender ==='FEMALE' ? 'Girl' : '-'"></div>
                <div v-if="studentInfo.gender ==='Male' || studentInfo.gender ==='MALE'" class="text-button mb-1" v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Male' ? 'Boy' : '-' || studentInfo && studentInfo.gender && studentInfo.gender ==='MALE' ? 'Boy' : '-'"></div>
              <span v-if="studentInfo.gender === null" class="mb-1">--</span>
            </v-card-subtitle>
          </v-col>
          <v-col cols="12" md="4">
            <v-card-subtitle class="font-weight-medium"><span class="body-1">Type :</span> {{ studentInfo && studentInfo.type ? studentInfo.type : '' }}</v-card-subtitle>
          </v-col>
        </v-row>
      </v-card>
      <!-- <v-row>
        <v-col cols="12" md="2" lg="2" xl="2" align="center">
          <v-img src="https://www.firstcryintellitots.com/wp-content/uploads/2020/05/Desktop-Intellitots-Logo.png" width="120"> </v-img>
        </v-col>
        <v-col cols="6" md="2" lg="2" xl="2">
          <div class="d-flex justify-space-between caption ">
            <div>
              <div class="grey--text text-subtitle-2  mb-1">
                Enquiry Code
              </div>
              <div class="text-button mb-1 " v-text="studentInfo && studentInfo.enquiryCode ? studentInfo.enquiryCode : ''"></div>
            </div>
          </div>
        </v-col>
        <v-col cols="6" md="2" lg="2" xl="2">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Student Name
              </div>
              <div class="text-button mb-1" v-text="studentInfo && studentInfo.name ? studentInfo.name : ''"></div>
            </div>
          </div>
        </v-col>
        <v-col cols="6" md="2" lg="2" xl="2">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Franchisee Name
              </div>
              <div class="text-button mb-1" v-text="studentInfo && studentInfo.franchiseeName ? studentInfo.franchiseeName : ''"></div>
            </div>
          </div>
        </v-col>
        <v-col cols="6" md="2" lg="2" xl="2">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Academic Year
              </div>
              <div class="text-button mb-1" v-text="studentInfo && studentInfo.academicYear ? studentInfo.academicYear : ''"></div>
            </div>
          </div>
        </v-col>
        <v-col cols="6" md="2" lg="2" xl="2">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Class
              </div>
              <div class="text-button mb-1" v-text=""></div>
            </div>
          </div>
        </v-col>
      </v-row> -->
      <!-- <v-row key="2"> -->
      <!-- <v-col cols="12" md="2" lg="2" xl="2" align="center"> </v-col> -->
      <!-- <v-col cols="6" md="2" lg="2" xl="2">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Parent / Guardian Name
              </div>
              <div class="text-button import _ from 'lodash'mb-1" v-text="studentInfo && studentInfo.fatherName ? studentInfo.fatherName : ''"></div>
            </div>
          </div>
        </v-col>
        <v-col cols="6" md="2" lg="2" xl="2">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Mobile
              </div>
              <div class="text-button mb-1" v-text="studentInfo && studentInfo.mobile ? studentInfo.mobile : ''"></div>
            </div>
          </div>
        </v-col>
        <v-col cols="6" md="4" lg="4" xl="4">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Email
              </div>
              <div class="text-button mb-1" v-text="studentInfo && studentInfo.email ? studentInfo.email : ''"></div>
            </div>
          </div>
        </v-col>
        <v-col cols="6" md="2" lg="2" xl="2">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Student Gender
              </div>
              <div class="text-button mb-1" v-text="studentInfo && studentInfo.gender ? studentInfo.gender : ''"></div>
            </div>
          </div>
        </v-col>
        <v-col cols="6" md="2" lg="2" xl="2">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Type
              </div>
              <div class="text-button mb-1" v-text="studentInfo && studentInfo.type ? studentInfo.type : ''"></div>
            </div>
          </div>
        </v-col>
      </v-row> -->
      <v-card-component>
        <v-data-table sort-by hide-default-footer :items-per-page="-1" :headers="headers" :items="paymentDetails"> </v-data-table>
      </v-card-component>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="status === 'APPROVAL_WAITING'" success id="rzp-button1" large color="success" @click="approvePlan('APPROVED')">
          <v-icon left>mdi-check</v-icon>
          Approve
        </v-btn>
        <v-btn v-if="status === 'APPROVAL_WAITING'" success id="rzp-button1" large color="error" @click="approvePlan('REJECTED')">
          <v-icon left>mdi-close</v-icon>
          Reject
        </v-btn>
        <v-btn v-else-if="status === 'APPROVED'" success icon-right="arrow-right-bold" id="rzp-button1" large color="primary" @click="captureAPI()">
          <v-icon left>mdi-check-circle</v-icon>
          Confirm
        </v-btn>
      </v-card-actions>
    </material-card>
    <v-snackbar v-model="snackbar" :timeout="snackbarTimeout">
      {{ snackbarMsg || 'Welcome' }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'

import moment from 'moment'
import VCardComponent from '@/components/template/VCardComponent.vue'
// import _ from 'lodash'
// import ThankYou from '../../Fees/payment/thankYou'
// import ErrorPage from '../../Fees/payment/error'

export default {
  name: 'ApprovePaymentDetails',
  components: { MaterialCard, VCardComponent },
  props: ['enquiryID'],
  data () {
    return {
      isLoading: false,
      disable: true,
      orderID: '',
      dialog: false,
      snackbar: false,
      limitCallBack: 0,
      snackbarMsg: '',
      snackbarTimeout: 2000,
      headers: this.getHeaders(),
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      SCHOOL_SERVICE_OFFLINE: constants.PAYMENT_TYPE.SCHOOL_SERVICE_OFFLINE,
      paymentDetails: [],
      studentInfo: null,
      paymentType: null,
      mode: '',
      status: ''
    }
  },
  async created () {
    await this.getAllInfo()
  },
  methods: {
    openSnackbar (msg) {
      if (!this.snackbar) {
        this.snackbarMsg = msg
        this.snackbar = true
        this.limitCallBack--
      } else {
        // Usage!
        if (this.limitCallBack < 1) {
          this.limitCallBack++
          setTimeout(this.openSnackbar(msg), this.snackbarTimeout)
        }
      }
    },
    getHeaders () {
      let header = [
        { text: 'Mode', value: 'mode', align: 'center' },
        { text: 'Recipt Number', value: 'paymentOrder.receiptNo', align: 'center' },
        { text: 'Status', value: 'status', align: 'center' },
        { text: 'Date of Payment', value: 'dateOfPayment', align: 'center' },
        { text: 'Amount (INR)', value: 'paymentOrder.amount', align: 'center' }
      ]
      if (this.mode === 'DEMAND_DRAFT') {
        header.push({ text: 'DD No', value: 'ddNO', align: 'center' })
        header.push({ text: 'Drawn No', value: 'drawnNO', align: 'center' })
      }
      if (this.mode === 'CHEQUE') {
        header.push({ text: 'IFSCCode', value: 'IFSCCode', align: 'center' })
        header.push({ text: 'MICRCode', value: 'MICRCode', align: 'center' })
        header.push({ text: 'chequeDate', value: 'chequeDate', align: 'center' })
        header.push({ text: 'chequeNO', value: 'chequeNO', align: 'center' })
        header.push({ text: 'bankName', value: 'bankName', align: 'center' })
        header.push({ text: 'branchName', value: 'branchName', align: 'center' })
      }
      if (this.mode === 'CARD_SWIPE') {
        header.push({ text: 'cardLastFourDigit', value: 'cardLastFourDigit', align: 'center' })
        header.push({ text: 'bankName', value: 'bankName', align: 'center' })
        header.push({ text: 'remark', value: 'remark', align: 'center' })
      }
      if (this.mode === 'INTERNET_PAYMENT') {
        header.push({ text: 'transactionID', value: 'transactionID', align: 'center' })
        header.push({ text: 'paymentType', value: 'paymentType', align: 'center' })
        header.push({ text: 'bankName', value: 'bankName', align: 'center' })
      }

      return header
    },

    approvePlan: async function (isActive) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        await http.post(`${constants.API_URL}/api/payments/offline/approve-payments`, { id: this.enquiryID, status: isActive })
        this.loadingComponent.close()
        // if (isActive === 'APPROVED') {
        //   await this.captureAPI(response)
        // }
        await this.getAllInfo()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },

    captureAPI: async function () {
      let that = this
      this.$buefy.dialog.confirm({
        message: `Do you want to Confirm Payments `,
        type: 'is-success',
        hasIcon: true,
        onConfirm: async function () {
          try {
            that.isLoading = true
            if (that.paymentType && that.paymentType === that.SCHOOL_SERVICE_OFFLINE) {
              await http.post(`${constants.API_URL}/api/service/payments/offline/capture`, { orderID: that.orderID })
            } else {
              await http.post(`${constants.API_URL}/api/payments/offline/capture`, { orderID: that.orderID })
            }
            that.isLoading = false
            that.model = 0
            that.$dialog.info({
              text: `Offline Payment Saved Successfully`,
              title: 'Success'
            })
            await that.getAllInfo()
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message

            console.log('error in fetching data : ', errorMessage)
            return that.$dialog.error({
              text: ` ${errorMessage}`,
              title: 'Error'
            })
          } finally {
            that.isLoading = false
          }
        }
      })
    },
    captureCashCard: async function () {},
    getAllInfo: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let response = await http.get(`${constants.API_URL}/api/payments/offline/${this.enquiryID}`)

        this.orderID = response.data.paymentOrder.orderID
        this.studentInfo = response.data.paymentOrder.notes
        this.paymentType = this.studentInfo.type
        this.mode = response.data.mode
        this.status = response.data.status
        this.paymentDetails = [response.data]
        this.paymentDetails.map(obj => {
          obj.dateOfPayment = moment(obj.dateOfPayment).format('YYYY-MM-DD')
          obj.paymentOrder.amount = Number(obj.paymentOrder.amount) / 100
        })
        this.headers = this.getHeaders()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    addTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) + Number(num2))
    },
    toFixed (number, length = 2) {
      return Number(Number(number).toFixed(length))
    }
  }
}
</script>
